module.exports = __webpack_public_path__ + "static/media/diners.0953e66e.png";